module.exports = __webpack_public_path__ + "static/media/angle-right-blue.861289aa.svg";